<template>
  <div class="main">
    <section
      class="w-100 text-center mb-3 d-flex mx-auto justify-content-center align-items-center"
    >
      <div class="flex-column">
        <img
          :src="useAsset('img/credit-line/success_cc.svg')"
          alt="icon"
          class="my-0 ms-0 me-2"
        />
      </div>
      <div class="flex-column h-100 align-content-center">
        <h1 class="fw-bolder text-black text-start fs-4 m-0">
          {{ t("CL_FULL_SCREEN_INVITATION_TITLE") }}
        </h1>
        <a
          :href="`${baseURL}/device?deviceTag=${deviceTag}&locale=${locale}`"
          class="text-decoration-none text-start fs-6 w-100 m-0"
          >{{ t("CL_FULL_SCREEN_INVITATION_ACCOUNT_DETAILS") }}</a
        >
      </div>
    </section>
    <section class="mx-3 p-2" id="offer">
      <NonEligible :country="country" />
    </section>
  </div>
</template>

<script lang="ts" setup>
import { useRoute } from "vue-router";
import { AuthenticationHelper } from "@/apps/credit-line/helpers/authentication.helper";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import NonEligible from "@/apps/credit-line/components/Invitation/NonEligible.vue";
import { getCurrentInstance, onBeforeMount } from "vue";
import { setLanguage } from "@/apps/credit-line/helpers/translations.helper";

const { t, locale } = useI18n();
const route = useRoute();

const country = route.query?.country;
const baseURL = process.env.VUE_APP_MERCHANT2_BASE_URL;
const deviceTag = AuthenticationHelper.getDeviceTag();

onBeforeMount(() => {
  setLanguage(getCurrentInstance()?.proxy);
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
.main {
  padding-top: 2%;
  width: 100%;
  height: 100%;
}
#offer {
  border-radius: 14px;
  background: #9ac31c;
  box-shadow: 0 0 11px 1px #e7e7e7;
  > img:hover {
    cursor: pointer;
  }
}
.main section a {
  color: $pj-color-green;
}
</style>
